import { Link } from "react-router-dom";
import { Search, ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function NotFoundPage() {
  return (
    <div className="min-h-screen bg-zinc-950 flex items-center justify-center px-4" data-testid="not-found-page">
      <div className="text-center max-w-md">
        {/* Brand mark */}
        <div className="w-14 h-14 rounded-2xl bg-green-500/10 border border-green-500/20 flex items-center justify-center mx-auto mb-8">
          <Search className="w-7 h-7 text-green-500" />
        </div>

        {/* 404 */}
        <h1 className="text-[7rem] sm:text-[9rem] font-bold leading-none tracking-tighter text-zinc-800 select-none">
          404
        </h1>

        <h2 className="text-lg sm:text-xl font-semibold text-white mt-2 mb-3">
          Page not found
        </h2>
        <p className="text-sm text-zinc-500 mb-8 leading-relaxed">
          The page you're looking for doesn't exist or has been moved.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-3">
          <Button asChild className="bg-green-600 hover:bg-green-700 text-white" data-testid="back-home-btn">
            <Link to="/">
              <ArrowLeft className="w-4 h-4 mr-2" />
              Back to Dashboard
            </Link>
          </Button>
        </div>

        <p className="text-xs text-zinc-700 mt-12">
          SEO Toolkit &middot; Emerald Consulting
        </p>
      </div>
    </div>
  );
}
